import cs from 'classnames';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useForm } from 'react-hook-form';
import { LINKS } from '@/Module/Core/Constant';
import type { ISearchProps } from '@/Module/DefaultLayout/Hook';
import { Button } from '@/Module/DesignSystem/Component';
import { IconSearch } from '@/Module/Icon';
import { searchResultLessonSetResetSearchAction } from '@/Module/Search/Store/Slice/SearchResultSlice';
import { useAppDispatch } from '@/Module/Store/Hook';
interface ISearchBoxProps {
  onToggle: ISearchProps['onToggle'];
}
interface IForm {
  query: string;
}
const SearchBoxDefault: FC<ISearchBoxProps> = ({
  onToggle
}) => {
  const router = useRouter();
  const {
    register,
    handleSubmit
  } = useForm<IForm>();
  const dispatch = useAppDispatch();
  const onSubmit = handleSubmit(data => {
    dispatch(searchResultLessonSetResetSearchAction());
    router.push({
      pathname: LINKS.SEARCH,
      query: {
        query: data.query
      }
    }, undefined, {
      shallow: `${router.pathname}/` === LINKS.SEARCH
    });
  });
  return <div className={cs(' rounded-xl flex gap-2 items-stretch transition-all w-full overflow-hidden  shadow-[0,0,0,0.16]')} data-sentry-component="SearchBoxDefault" data-sentry-source-file="SearchBoxDefault.tsx">
      <form className="flex flex-1" onSubmit={onSubmit}>
        <Button radius="none" bold className="rounded-l-none  bg-grayOne !shadow-none" onClick={onToggle} afterIcon={<IconSearch size="small" className="text-blackThree" />} data-sentry-element="Button" data-sentry-source-file="SearchBoxDefault.tsx" />
        <input className="w-full flex-1 border-none bg-grayOne text-blackThree  " placeholder="محتوای مد نظرتان را جستجو کنید..." {...register('query')} />
      </form>
    </div>;
};
export default SearchBoxDefault;